(ns manage.content-variant-page.entities.tagging.db
  (:require [clojure.string :as str]
            [common.util :as util]
            [manage.slate-editor.common :as slate-editor.common]
            [manage.slate-editor.util :as slate-editor.util]
            [re-frame.core :as rf]))

(rf/reg-sub ::tagging-params
  (fn [db _]
    (::tagging-params db)))

(defn- query-param-value->values
  "Segments a string into multiple parts, to separate macro text and non-macro text.
   Returns a (possibly empty) vector of strings."
  [value]
  (->> (slate-editor.util/re-partition-indexed (slate-editor.common/macro-node-regex) value)
       (map (fn [{:keys [text match]}]
              (if (some? text)
                text
                (-> match first second))))
       (remove #{""})
       vec))

(defn- params->url [params]
  (->> params
       (map (fn [[attribute value]]
              (str attribute
                   (when-not (str/blank? value) "=")
                   value)))
       (str/join "&")))

(defn- url->params [url]
  (let [url (cond-> url (str/starts-with? url "?") (subs 1))]
    (->> (str/split url #"&" -1) ; the -1 is needed, see split's docs
         (mapv (fn [attribute-value]
                 (let [[_ attribute value] (re-matches #"([^=]*)(?:=(.*))?" attribute-value)]
                   [attribute value]))))))

(defn value-to-save [db]
  (->> (::tagging-params db)
       (mapv (fn [[attribute value]]
               {:name attribute
                :values (query-param-value->values value)}))))

(defn content-has-changed? [db]
  (let [value-in-resource (-> db :resource.adset/one :value :clickThroughUrlTagging)]
    (not= value-in-resource (value-to-save db))))

(rf/reg-sub ::tagging-url
  :<- [::tagging-params]
  (fn [params _]
    (params->url params)))

(rf/reg-event-db ::set-tagging-url
  (fn [db [_ url]]
    (assoc db ::tagging-params (url->params url))))

(rf/reg-event-db ::add-tagging-param
  (fn [db _]
    (update db ::tagging-params (fnil conj []) [nil nil])))

(rf/reg-event-db ::delete-tagging-param
  (fn [db [_ index]]
    (update db ::tagging-params util/vec-dissoc index)))

(rf/reg-event-db ::set-tagging-attribute
  (fn [db [_ index attribute]]
    (assoc-in db [::tagging-params index 0] attribute)))

(rf/reg-event-db ::set-tagging-value
  (fn [db [_ index value]]
    (assoc-in db [::tagging-params index 1] value)))
